import * as Yup from "yup";
import { getInitialValues } from "layouts/views/common/common";

const formField = {
  companyCode: {
    name: "companyCode",
    label: "Company Code",
    type: "text",
    errorMsg: "Company code is required.",
    required: true,
    //disabled: true,
    editable:false,
    maxLength: 20,
  },
  companyName: {
    name: "companyName",
    label: "Company Name",
    type: "text",
    errorMsg: "Company name is required.",
    required: true,
    maxLength: 100,
  },
  shortName: {
    name: "shortName",
    label: "Short Name",
    type: "text",
    maxLength: 30,
  },
  email: {
    name: "email",
    label: "Email",
    type: "text",
  },
  phoneNo: {
    name: "phoneNo",
    label: "Phone No",
    type: "text",
    errorMsg: "Phone no is required.",
    required: true,
  },
  faxNo: {
    name: "faxNo",
    label: "Fax No",
    type: "text",
  },
  address1: {
    name: "address1",
    label: "Address 1",
    type: "text",
    maxLength: 200,
  },
  address2: {
    name: "address2",
    label: "Address 2",
    type: "text",
    maxLength: 200,
  },
  city: {
    name: "city",
    label: "City",
    type: "text",
  },
  state: {
    name: "state",
    label: "State",
    type: "select",
  },
  postcode: {
    name: "postcode",
    label: "Postcode",
    type: "text",
  },
  country: {
    name: "country",
    label: "Country",
    type: "select",
  },
};

const {
  companyCode,
  companyName,
  shortName,
  address1,
  address2,
  city,
  state,
  postcode,
  country,
  phoneNo,
  faxNo,
  email,
} = formField;

export const formRender = [
  [companyCode, companyName],
  [shortName, email],
  [phoneNo, faxNo],
  [address1, address2],
  [city, state],
  [postcode, country],
];

export const initialValues = getInitialValues(formField);

export const companyValidations = Yup.object().shape({
  [companyCode.name]: Yup.string().max(20).required(companyCode.errorMsg),
  [companyName.name]: Yup.string().max(100).required(companyName.errorMsg),
  [phoneNo.name]: Yup.string().max(20).required(phoneNo.errorMsg),
});
